import { useParams } from 'react-router-dom'
import { PlaceholderPage } from './PlaceholderPage'

export default function AdminProjectDetail() {
  const { id } = useParams()
  return <PlaceholderPage title={`Admin: Project ${id}`} route="/admin/projects/:id" />
}
